/**
 * 404 / NotFound page — rendered for any path that doesn't match a known
 * public route (audit B503). Lives in the public surface so visitors who
 * mistype a URL get a friendly recovery affordance instead of silently
 * landing on the marketing page with no signal.
 */

import React from 'react';
import styles from '../styles/NotFoundPage.module.css';
import { STRING_CONSTANTS } from '../constants/stringConstants';

interface NotFoundPageProps {
  onGoHome: () => void;
  onSignIn?: () => void;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({ onGoHome, onSignIn }) => {
  const strings = STRING_CONSTANTS.NOT_FOUND;
  return (
    <div className={styles.container} role="main">
      <div className={styles.card}>
        <span className={styles.badge}>{strings.BADGE}</span>
        <h1 className={styles.headline}>{strings.HEADLINE}</h1>
        <p className={styles.subheadline}>{strings.SUBHEADLINE}</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={onGoHome}
          >
            {strings.PRIMARY_CTA}
          </button>
          {onSignIn && (
            <button
              type="button"
              className={styles.secondaryButton}
              onClick={onSignIn}
            >
              {strings.SECONDARY_CTA}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
